import { COVERED_CRAWLERS } from '@prerender/diagnostics-api';

// The name each vendor uses for its own agent, against the lower-case name the rollup writes.
// Typed to the covered list so a crawler added there without a label fails the build.
export const CRAWLER_LABELS: Record<(typeof COVERED_CRAWLERS)[number], string> = {
  googlebot: 'Googlebot',
  bingbot: 'Bingbot',
  applebot: 'Applebot',
  gptbot: 'GPTBot',
  chatgpt: 'ChatGPT',
  claudebot: 'ClaudeBot',
  'anthropic-ai': 'Anthropic AI',
  perplexitybot: 'PerplexityBot',
  amazonbot: 'Amazonbot',
  meta: 'Meta',
  linkedinbot: 'LinkedInBot',
};

// A Map, not the record itself: a crawler named `__proto__` or `constructor` would otherwise
// find a property every object inherits, and the fallback would never fire — the address bar
// accepts any crawler name, so this is reachable.
const labelled = new Map<string, string>(Object.entries(CRAWLER_LABELS));

export function crawlerLabel(crawler: string): string {
  return labelled.get(crawler) ?? crawler;
}

export function providerCrawlerLabel(provider: string, crawler: string): string {
  const label = crawlerLabel(crawler);
  return label === provider ? provider : `${provider} · ${label}`;
}
